export default __webpack_public_path__ + "static/media/products-4-m.7f2ad8c6.webp";